import React from 'react';
import PostalCodeInputWUT from '../../../ui/address-input/postal-code-input-wut';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
import JapanPostalCodeMarkWUT from './japan-postal-code-mark-wut';
const JapanPostalCodeWUT = ({ autocomplete, ...props })=>{
    const prefix = /*#__PURE__*/ React.createElement(JapanPostalCodeMarkWUT, null);
    return autocomplete ? /*#__PURE__*/ React.createElement(PostalCodeInputWUT, {
        ...props,
        prefix: prefix
    }) : /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        prefix: prefix
    });
};
export default JapanPostalCodeWUT;

//# sourceMappingURL=japan-postal-code-wut.js.map